// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import actionCreators from "@modules/shared/actionCreator";
import { GetAbsenceReasons } from "@modules/shared/constants/actions";
import config from "@config";

type ListRequest = $Exact<{
  clientId: string,
  activeOnly: boolean,
}>;

export function* onGetAbsenceReasons({ payload }: Action<ListRequest>): Generator<*, void, Object> {
  try {
    if (!payload || !payload.clientId) {
      throw Error("Invalid payload provided");
    }

    const response = yield call(
      http.get,
      `${config.endpointBaseUrl}api/v1/service-admin/client/${payload.clientId}/approval/client-absence-reason`,
      {
        params: {
          activeOnly: payload.activeOnly,
        },
      },
    );
    yield put(actionCreators.GetAbsenceReasonsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetAbsenceReasonsError(e.response));
  }
}

export function* SharedSagas(): Generator<*, void, void> {
  yield all([takeEvery(GetAbsenceReasons, onGetAbsenceReasons)]);
}

export default SharedSagas;
